export const CLAIM_STATUS = {
  verified: 'verified',
  rejected: 'rejected',
  pending: 'pending'
} as const
